import { useState } from "react";

import SendButton from "../../asset/send.svg";
import { motion, useAnimationControls } from "framer-motion";
import Emoji from "../../asset/emoji.gif";
import useWindowDimensions from "../../hooks/useGetSize.js";

import "./contact.css";

export default function Contact() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [company, setCompany] = useState("");
  const [message, setMessage] = useState("");

  const { width } = useWindowDimensions();

  const [isSent, setIsSent] = useState(false);

  const controls = useAnimationControls();

  const handleSubmit = async (event) => {
    event.preventDefault();
    const body = {
      channel: "contactus",
      text: `***Message from Raadco Website*** \n email : ${email} \n name : ${name} \n company : ${company} \n message : ${message}   `,
    };

    try {
      await fetch(
        "https://chat.raadco.com.au/hooks/n84xf96pn3gqfjcj4qtparw4jr",
        {
          method: "POST",
          body: JSON.stringify(body),
          mode: "no-cors",
        }
      );
      // const res = await data;

      // console.log(res.ok, "result");
      setName("");
      setCompany("");
      setMessage("");
      setEmail("");
      setIsSent(false);
      controls.start("visible");
    } catch (error) {
      setIsSent(!isSent);
      console.log(error);
    }
  };

  const handleClose = () => {
    controls.start("hidden");
  };

  const varianth = {
    hidden: { height: "160px", width: "39%" },
    visible: {
      height: ["30%", "100%"],
      width: width >= 1536 ? ["39%", "100%"] : "",
    },
  };

  const contact = {
    hidden: { y: 0 },
    visible: { y: width >= 1536 ? [0, -250] : [] },
  };
  const variantsvg = {
    hidden: { fillOpacity: 0.12, x: 0, y: 0, scale: 1 },

    visible: {
      x: width <= 768 ? [0, 150] : width >= 1536 ? [0, -50] : [0, 250],
      y: width >= 1536 ? [0, 200] : [0, 10],
      scale: width >= 1536 ? [1, 1.3] : [1, 2],
      fillOpacity: [0.12, 1],
    },
  };
  const varianttext = {
    hidden: { opacity: 0, x: 0, y: 0 },

    visible: {
      x: 0,
      y: 0,
      opacity: 1,
    },
  };
  const varianttext2 = {
    hidden: { opacity: 1 },

    visible: {
      opacity: 0,
    },
  };
  return (
    <section id="contact" className="  mx-auto  xl:max-w-[1184px] ">
      <div className="w-full    xl:py-[118px]    px-0 py-0 mx-auto md:py-0  ">
        <div className="relative bg-white shadow-xl">
          <h2 className="sr-only">contact us</h2>

          <div className="  relative w-full   min-h-[500px] flex xl:flex-row flex-col   ">
            {/* Contact information */}
            <div className="h-[160px] xl:hidden "></div>
            <div className="w-[464px] hidden xl:flex "></div>

            <motion.div
              variants={varianth}
              initial="hidden"
              animate={controls}
              transition={{ duration: 0.5, ease: "easeInOut" }}
              className={
                width <= 1536
                  ? "absolute left-0 top-0  h-[15vh] xl:min-h-[550px]  z-[999]  w-full min-w-full text-center   flex flex-col   xl:min-w-[39%]  overflow-hidden    justify-center items-center   bg-[#433CAE] "
                  : "absolute left-0 top-0  h-[15vh] xl:min-h-[745px]  z-[999]    text-center   flex flex-col   xl:min-w-[39%]  overflow-hidden    justify-center items-center   bg-[#433CAE]  "
              }
            >
              <motion.h3
                initial="hidden"
                variants={contact}
                animate={controls}
                transition={{ duration: 0.3, type: "tween", ease: "easeInOut" }}
                className="absolute xl:top-[277px]    top-[10px]   text-center  justify-center   font-bold text-[#00E4FF] leading-[33px]   text-[12px] "
              >
                Contact Us
              </motion.h3>

              <motion.div
                variants={varianttext2}
                transition={{ duration: 0.1, ease: "easeIn" }}
                animate={controls}
                className="   absolute top-[50px] xl:top-[350px]   text-white   text-center max-w-[200px]  md:max-w-[374px]    xl:min-w-[432px]     contact-m md:contact-t lg:contact-d xl:contact-xl"
              >
                Leave Us a{" "}
                <span className=" text-[#00E4FF]   contact-m md:contact-t lg:contact-d xl:contact-xl">
                  Message
                </span>
              </motion.div>
              <motion.div
                style={{ position: "absolute" }}
                initial="hidden"
                variants={varianttext}
                transition={{ duration: 0 }}
                animate={controls}
                className="text-white absolute top-[100px]  text-center max-w-[250px]  md:max-w-[374px]    xl:min-w-[600px]     contact-m md:contact-t lg:contact-d xl:contact-xl"
              >
                Your message has been
                <span className="  text-[#00E4FF]   contact-m md:contact-t lg:contact-d xl:contact-xl">
                  {" "}
                  sent
                </span>
              </motion.div>
              <div className="relative ">
                <motion.svg
                  initial="hidden"
                  variants={variantsvg}
                  // fill="#ffffff1f"
                  fill="#fff"
                  animate={controls}
                  transition={{ duration: 0.8 }}
                  className="w-[101px] h-[96px]   md:w-[147px] md:h-[147px]  top-[-30px] left-[-180px]   md:left-[-300px] md:top-[-85px]    lg:top-[-85px] lg:left-[-300px]   absolute xl:top-[-250px] xl:left-[10px]  "
                  viewBox="0 0 150 150"
                >
                  <path
                    fill="#fff"
                    d="M136.976 0.428228C135.949 0.713818 133.75 1.57001 132.091 2.33119C130.431 3.09238 126.875 4.46979 124.189 5.39182C111.28 9.82264 107.294 11.2878 101.048 13.8977C97.3388 15.4478 91.9762 17.615 89.1314 18.7137C86.2865 19.8125 82.7305 21.2771 81.2291 21.9681C79.7277 22.6591 77.2061 23.6785 75.6257 24.2332C69.7484 26.2964 65.17 28.1541 48.6143 35.1927C45.6115 36.4694 39.5986 38.7116 35.2523 40.1757C30.9061 41.6397 25.6044 43.5929 23.4708 44.5164C21.3372 45.4399 17.1992 47.0246 14.2754 48.0379C11.3516 49.0515 7.4809 50.3913 5.67402 51.0159C1.75162 52.372 0.319157 53.2435 0.0593881 54.4315C-0.440897 56.7211 2.11196 57.8198 11.8329 59.499C17.5527 60.4869 21.2731 61.4135 25.7006 62.9535C30.1406 64.4978 38.994 67.9925 39.4908 68.3968C39.7514 68.609 39.852 70.0049 39.8569 73.4903C39.8609 76.1313 39.9825 78.8117 40.127 79.447C40.2715 80.0822 40.46 84.8902 40.546 90.1313C40.7054 99.8696 41.0342 104.578 42.2983 115.245C43.2221 123.039 43.5106 124.651 44.181 125.759C45.4003 127.774 48.0528 128.04 49.4701 126.29C51.4703 123.82 55.12 118.973 56.7301 116.649C57.7166 115.225 60.091 112.379 62.0062 110.325C67.6907 104.229 69.0406 102.538 72.9274 96.6378C76.0806 91.852 76.6314 90.8489 76.6314 89.8931C76.6314 89.1056 76.7386 88.8157 76.9906 88.9234C77.1883 89.0074 79.8067 90.1867 82.8096 91.5439C86.2796 93.1122 89.6308 94.3932 92.0049 95.0585C100.141 97.3386 102.265 98.1402 106.098 100.375C108.483 101.767 109.15 100.992 111.064 94.6072C111.707 92.4631 113.731 86.2257 115.562 80.7464C117.394 75.2671 119.915 67.5042 121.166 63.4958C126.123 47.6108 129.429 38.2349 132.413 31.5967C136.687 22.0894 141.714 9.82986 142.711 6.48162C143.743 3.01413 143.832 1.36065 143.024 0.62661C142.203 -0.120427 139.295 -0.215719 136.976 0.428228ZM139.562 5.24369C139.562 5.69763 136.607 13.1166 134.677 17.5067C133.456 20.2861 131.802 24.1194 131.004 26.0253C130.205 27.9311 128.702 31.284 127.665 33.4757C126.628 35.6678 125.212 39.2412 124.519 41.4168C123.826 43.5926 122.672 46.9969 121.954 48.9822C121.236 50.9674 119.327 56.7442 117.713 61.8193C116.098 66.8943 114.358 72.0323 113.845 73.2365C113.332 74.4409 111.462 79.9044 109.69 85.3773C107.919 90.8506 106.435 95.3626 106.394 95.4042C106.353 95.4454 105.103 94.9011 103.616 94.1939C100.678 92.7972 97.9782 91.8838 93.298 90.7039C90.163 89.9136 85.3837 87.9075 78.4992 84.4923C69.4596 80.0077 63.5306 77.6043 61.289 77.5163C59.4712 77.4446 58.7953 78.5061 57.8939 82.8495C57.6513 84.0178 57.6347 84.755 57.8387 85.304C58.0611 85.9026 57.9341 87.1841 57.3031 90.7088C56.6358 94.4368 56.5378 95.4922 56.7956 96.1731C57.0689 96.8959 57.1709 96.9583 57.5045 96.6063C57.9398 96.1469 58.9335 91.8509 59.3697 88.5431C59.6913 86.1039 60.8005 82.6 61.543 81.6782C61.6332 81.5659 65.5263 83.2838 69.7349 85.2927C71.7105 86.2358 73.5648 87.0935 73.8556 87.1986C74.3191 87.3661 74.2211 87.5722 73.063 88.8665C72.3363 89.6788 70.557 92.2266 69.109 94.5283C66.0812 99.342 64.3533 101.557 59.2855 107.124C57.2835 109.322 54.4212 112.855 52.9244 114.973C50.218 118.803 49.4011 119.749 49.7209 118.683C50.031 117.649 53.8922 101.095 54.1916 99.5162C54.3574 98.6427 54.8177 95.2846 55.2151 92.0536C56.0157 85.5396 57.1338 80.0562 58.0206 78.2928C58.7809 76.7813 63.6197 71.8279 69.0165 67.0364C71.3872 64.9316 79.6018 56.9873 87.2713 49.3821C94.9405 41.7769 102.366 34.58 103.773 33.3888C105.179 32.1977 107.568 30.1341 109.081 28.8032C110.594 27.4723 112.738 25.7013 113.844 24.8673C116.561 22.8194 119.162 20.6808 122.093 18.0842C123.438 16.8931 126.062 15.0089 127.925 13.8971C129.787 12.7854 132.424 10.9003 133.785 9.70829C138.916 5.21077 139.562 4.71178 139.562 5.24369ZM124.045 9.84315C124.045 9.91649 122.914 10.6471 121.531 11.4666C120.148 12.2861 117.982 13.7588 116.717 14.7392C115.453 15.7195 113.513 17.1599 112.407 17.9401C111.301 18.7204 108.446 20.8829 106.065 22.7458C103.682 24.6089 100.126 27.1344 98.1624 28.3585C96.198 29.5826 93.2951 31.4653 91.7109 32.5422C90.1268 33.619 87.5406 35.1985 85.9638 36.0524C84.3871 36.906 80.0581 39.6042 76.3441 42.0486C68.9427 46.9192 66.049 48.6486 62.0878 50.5681C60.2858 51.4413 58.0579 52.9455 54.9439 55.3907C52.4551 57.3454 49.1077 59.8995 47.5051 61.0664C45.9025 62.2333 44.0666 63.6977 43.4253 64.3205L42.2595 65.4531L41.6348 64.7846C41.2911 64.417 39.4236 63.38 37.4845 62.4797C29.4986 58.7725 20.2829 55.9899 13.3467 55.1918C7.3197 54.4982 7.43751 54.5666 10.2711 53.4092C11.6042 52.8649 14.182 51.9674 15.9995 51.415C19.932 50.2195 21.705 49.5268 25.9133 47.5404C27.6518 46.7197 30.5612 45.6131 32.3788 45.0809C34.1963 44.549 36.7825 43.7243 38.1259 43.2481C39.4692 42.772 41.2658 42.1693 42.1181 41.9091C42.9704 41.6487 44.91 40.8751 46.4284 40.1901C47.9468 39.5055 50.9347 38.2892 53.0683 37.4879C55.2019 36.6865 59.7278 34.8442 63.1257 33.3943C66.5237 31.9444 71.4809 29.9851 74.1418 29.0409C76.8027 28.0963 80.8113 26.5592 83.0498 25.6248C85.2883 24.6903 88.2837 23.5021 89.7061 22.984C91.1285 22.4663 95.2017 20.8128 98.7578 19.31C107.836 15.4729 108.774 15.1091 115.737 12.7181C119.148 11.5466 122.381 10.3956 122.921 10.1605C124.056 9.66527 124.045 9.66815 124.045 9.84315ZM121.171 15.3271C121.171 15.399 120.59 15.8599 119.878 16.3516C118.246 17.4801 118.18 17.2789 119.791 16.088C121.019 15.1804 121.171 15.0964 121.171 15.3271ZM98.183 33.3189C96.3655 35.0238 89.3828 41.8626 82.6659 48.5164C75.949 55.1701 68.4447 62.3974 65.9898 64.5767C60.4303 69.5123 56.2763 73.911 55.1404 76.0649C53.9925 78.2419 52.9062 83.2318 52.1881 89.6277C51.3571 97.0313 50.66 101.041 48.762 109.334C47.835 113.384 47.0672 116.623 47.0554 116.531C46.6367 113.289 46.0712 109.572 45.7402 107.89C45.1385 104.831 44.5465 100.289 43.8767 93.5965C43.5589 90.4201 43.1778 86.9115 43.0301 85.7998C42.2123 79.6491 42.0767 77.4042 42.3985 75.3488C42.5773 74.2067 42.7256 72.1926 42.7279 70.8729C42.7304 69.5536 42.8273 68.3379 42.9434 68.1715C43.2586 67.7205 46.2632 65.4771 49.189 63.5082C50.6114 62.551 53.8404 60.1254 56.3646 58.1179C58.9039 56.0982 61.5349 54.2461 62.2553 53.9715C64.3211 53.1831 70.5188 49.5178 77.0625 45.2138C80.3814 43.0307 84.584 40.4318 86.4015 39.4382C88.219 38.4448 91.0638 36.7096 92.723 35.5826C95.583 33.64 101.035 30.2554 101.344 30.2306C101.423 30.2242 100.001 31.6141 98.183 33.3189ZM58.8873 62.538C58.0844 63.2108 58.0183 64.2868 58.7795 64.2868C59.0758 64.2868 59.7223 64.3679 60.2163 64.4672C61.0441 64.6336 61.1143 64.5871 61.1143 63.8706C61.1143 62.0999 60.1197 61.5048 58.8873 62.538ZM55.5858 64.5553C54.9927 65.4066 55.1002 68.0424 55.7445 68.4407C56.5712 68.9518 57.3786 67.7444 57.3786 65.9974C57.3786 64.9073 57.2551 64.5293 56.8229 64.2969C56.0832 63.8992 56.0364 63.909 55.5858 64.5553ZM52.0215 65.0124C51.9295 65.2527 51.991 65.6145 52.158 65.8163C52.3246 66.0185 52.5008 66.9454 52.5494 67.8764C52.6476 69.7695 53.2131 70.4793 54.1459 69.8807C54.8525 69.4271 54.8476 66.4435 54.139 65.3563C53.5726 64.488 52.3005 64.2813 52.0215 65.0124ZM48.6873 67.9685C48.6252 68.2466 48.6899 68.7987 48.831 69.1958C48.9721 69.5928 49.0063 70.4649 48.9068 71.134C48.6968 72.5475 49.1063 73.5273 49.9074 73.5273C50.2123 73.5273 50.5976 73.2726 50.7632 72.9616C51.1353 72.2628 50.8439 69.3586 50.291 68.2573C49.8436 67.3656 48.8614 67.1886 48.6873 67.9685ZM26.0972 80.5356C25.3452 80.8986 22.0883 85.5486 21.5423 87.038C20.965 88.6132 21.7145 89.9138 23.011 89.5867C23.9613 89.347 28.4926 81.4403 28.1673 80.589C27.9794 80.0964 27.0561 80.0724 26.0972 80.5356ZM65.0243 90.155C64.6108 91.2381 64.8499 93.6632 65.4456 94.4238C66.1111 95.2742 66.5131 95.3597 67.2608 94.8104C67.7257 94.4688 67.7384 94.2733 67.4059 92.5725C67.2056 91.5474 66.8519 90.4813 66.6197 90.2035C66.0938 89.574 65.2559 89.5486 65.0243 90.155ZM62.2574 92.5976C61.8079 93.4414 61.8165 96.5202 62.2697 97.0692C62.4757 97.3187 62.9142 97.4838 63.2441 97.4365C63.7858 97.3588 63.8525 97.1298 63.9286 95.0851C64.0134 92.811 63.7599 92.0083 62.9571 92.0083C62.7447 92.0083 62.43 92.2733 62.2574 92.5976ZM18.4484 97.025C17.1863 99.189 15.9605 103.212 15.9582 105.198C15.9559 107.301 16.3389 108.179 17.2582 108.179C18.4208 108.179 18.932 107.244 19.1875 104.647C19.3168 103.334 19.6208 101.545 19.8627 100.671C20.5883 98.0539 20.3734 95.7622 19.4024 95.7622C19.2826 95.7622 18.8533 96.3305 18.4484 97.025ZM18.0633 118.718C17.2889 119.707 17.2398 121.487 17.905 124.438C18.6096 127.563 19.4648 129.26 21.0374 130.651C23.9725 133.247 24.1512 131.632 21.7119 124.561C20.7219 121.692 19.6372 119.023 19.3012 118.63L18.6903 117.917L18.0633 118.718ZM119.032 119.021C115.377 120.328 115.805 121.254 120.463 122.12C121.757 122.36 124.113 123.136 125.823 123.885C129.56 125.519 131.096 125.795 132.066 125.006C133.458 123.873 132.263 122.063 129.009 120.376C124.736 118.161 122.345 117.837 119.032 119.021ZM101.813 119.027C100.886 119.256 99.3348 119.862 98.3652 120.374C96.3443 121.442 93.0107 124.597 93.0107 125.443C93.0107 126.653 93.6207 126.635 97.0336 125.322C98.8511 124.622 101.373 123.727 102.637 123.331C105.77 122.351 107.235 121.487 107.235 120.618C107.235 119.077 104.664 118.322 101.813 119.027ZM138.869 127.787C138.399 128.309 138.412 128.41 139.127 129.829C140.185 131.927 143.246 134.944 144.57 135.194C146.775 135.61 147.724 133.848 146.381 131.828C145.668 130.757 140.673 127.238 139.865 127.238C139.589 127.238 139.141 127.485 138.869 127.787ZM82.6659 132.99C80.092 133.69 78.0544 134.791 76.1921 136.486C75.324 137.276 74.4964 137.922 74.353 137.922C74.2096 137.922 73.8084 138.383 73.4619 138.947C72.8539 139.935 72.8498 139.991 73.3481 140.545C73.7791 141.023 74.0811 141.086 75.176 140.924C76.9386 140.664 77.5774 140.407 79.936 139.005C83.7282 136.75 85.696 134.695 85.4848 133.211C85.3699 132.405 84.9391 132.371 82.6659 132.99ZM28.2486 136.13C27.7394 136.958 31.6598 142.008 34.2466 143.856C36.0848 145.169 37.4871 145.547 39.0026 145.137C40.5914 144.707 40.7698 144.071 39.5626 143.14C39.033 142.732 37.3236 141.279 35.7638 139.912C34.204 138.544 32.2305 137.083 31.3782 136.663C29.8475 135.91 28.5228 135.684 28.2486 136.13ZM57.666 143.016C57.4289 143.081 55.6186 143.362 53.643 143.641C50.1793 144.13 50.0511 144.174 50.0511 144.844C50.0511 145.422 50.3436 145.662 51.7752 146.26C53.2743 146.886 53.9496 146.983 56.9476 146.999C60.9634 147.021 62.9996 146.469 63.297 145.278C63.5254 144.363 63.2703 144.024 61.8691 143.385C60.7927 142.894 58.7654 142.716 57.666 143.016Z"
                  />
                </motion.svg>
              </div>

              <motion.div
                initial="hidden"
                variants={varianttext}
                animate={controls}
                transition={{ duration: 0 }}
                className=" absolute bottom-[28%]  flex items-center justify-center gap-[4px]"
              >
                <p className=" text-white text-[28px] font-light leading-[44px] ">
                  Thank you{" "}
                </p>
                <img src={Emoji} alt="emoji" className="w-[40px] h-[40px]" />
              </motion.div>
              <motion.div
                initial="hidden"
                variants={varianttext}
                animate={controls}
                transition={{ duration: 0, ease: "easeInOut" }}
                className=" absolute bottom-[10%] "
              >
                <button
                  onClick={() => {
                    // setIsOpen(true);
                    handleClose();
                  }}
                  className="bye"
                >
                  Go back
                </button>
              </motion.div>
            </motion.div>

            {/* Contact form */}

            <div className="flex-1  px-[19px]  pb-[48px]   md:px-[84px] md:py-[64px]     lg:px-[212px] lg:py-[88px]   xl:py-[48px] xl:px-[76px]  lg:col-span-2 ">
              <form
                onSubmit={handleSubmit}
                className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 sm:gap-x-8"
              >
                {/* <div className="mx-[30px]"> */}
                <div className="flex mt-[10px]    items-center col-span-2 sm:col-span-2 md:col-span-1 lg:col-span-1  xl:col-span-1  pt-[16px]   gap-[8px]">
                  <label
                    htmlFor="name"
                    className=" w-[50px] block text-sm font-medium text-gray-700"
                  >
                    From :
                  </label>
                  <div className="flex-1 border-b border-gray-300 focus-within:border-indigo-600">
                    <input
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      type="email"
                      name="email"
                      className="block w-full bg-white border-0 border-b border-transparent focus:border-indigo-600 focus:ring-0 sm:text-sm placeholder:text-[#9CA3AF]  placeholder:text-[18px] placeholder:font-medium    "
                      placeholder="Your Email"
                    />
                  </div>
                </div>
                <div className="hidden md:block "></div>
                <div className=" pt-[8px] col-span-2 sm:col-span-2 md:col-span-1 lg:col-span-1  xl:col-span-1     md:pt-[40px]   ">
                  <span className="w-[50px]  ">To : </span>
                  <span className="text-[#433CAE] xl:text-[18px] xl:font-bold xl:leading-[90px]  ">
                    info@raadco.com.au{" "}
                  </span>{" "}
                </div>
                <div className="hidden md:block "></div>
                <div className="col-span-2">
                  <p className="text-[#111827] text-start leading-[90px]  font-bold text-[32px] ">
                    Hi !
                  </p>
                </div>
                {/* <div className="hidden md:block "></div> */}
                <div className="flex items-center col-span-2 sm:col-span-2 md:col-span-1 lg:col-span-1  xl:col-span-1  gap-[8px]">
                  <label
                    htmlFor="name"
                    className="block w-[50px] text-sm font-medium text-gray-700"
                  >
                    I’m
                  </label>
                  <div className="flex-1 border-b border-gray-300 focus-within:border-indigo-600">
                    <input
                      required
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      type="text"
                      name="name"
                      id="name"
                      className="block w-full bg-white border-0 border-b border-transparent focus:border-indigo-600 focus:ring-0 sm:text-sm placeholder:text-[#9CA3AF]  placeholder:text-[18px] placeholder:font-medium    "
                      placeholder="Your Name"
                    />
                  </div>
                </div>
                {/* <div className=""></div> */}
                <div className="flex items-center col-span-2 sm:col-span-2 md:col-span-1 lg:col-span-1  xl:col-span-1  gap-[8px]">
                  <label
                    htmlFor="name"
                    className="block w-[50px]  text-sm font-medium text-gray-700"
                  >
                    From
                  </label>
                  <div className="flex-1 border-b border-gray-300 focus-within:border-indigo-600">
                    <input
                      value={company}
                      onChange={(e) => setCompany(e.target.value)}
                      type="text"
                      name="company"
                      id="company"
                      className="block w-full bg-white border-0 border-b border-transparent focus:border-indigo-600 focus:ring-0 sm:text-sm placeholder:text-[#9CA3AF]  placeholder:text-[18px] placeholder:font-medium    "
                      placeholder="Your Company"
                    />
                  </div>
                </div>
                <div className="col-span-2   mt-[40px]  border-b border-gray-200  focus-within:border-indigo-600">
                  <label htmlFor="comment" className="sr-only">
                    ADD Your Massege ...
                  </label>
                  <textarea
                    required
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    rows={5}
                    name="comment"
                    id="comment"
                    className="block w-full p-0 pb-2 border-0 border-b border-transparent resize-none focus:ring-0 focus:border-indigo-600 sm:text-sm placeholder:text-[#9CA3AF]  placeholder:text-[18px] placeholder:font-medium      "
                    placeholder="Your Massege ..."
                  />
                </div>
                <div>
                  <p className="text-[#111827]  leading-[90px]  font-medium text-[18px] ">
                    Thanks.
                  </p>
                </div>
                {/* </div> */}
                <div className=" pt-[40px]  flex-col   md:pt-[30px]    flex items-center justify-center flex-1 col-span-2  space-y-3  ">
                  <button
                    // onClick={() => setIsSent(!isSent)}
                    type="submit"
                    className="w-full h-full send-btn-m md:send-btn-t lg:send-btn-d xl:send-btn-xl"
                  >
                    Send
                    <img src={SendButton} alt="send" />
                  </button>
                  {isSent ? (
                    <p className="text-[18px]  text-red-600  ">
                      error sending message
                    </p>
                  ) : null}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
